export default __webpack_public_path__ + "static/media/undraw_Hire_re_gn5j.9a041395.svg";